import { render, staticRenderFns } from "./shopsCommodity.vue?vue&type=template&id=e10cbb0a&scoped=true"
import script from "./shopsCommodity.vue?vue&type=script&lang=js"
export * from "./shopsCommodity.vue?vue&type=script&lang=js"
import style0 from "./shopsCommodity.vue?vue&type=style&index=0&id=e10cbb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10cbb0a",
  null
  
)

export default component.exports